var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowXan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-management-overview",
    transform: "translate(-1798, -347)",
    fill: "#5464B0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(529, 184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(34, 163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1235, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0766129,0 22,4.9233871 22,11 C22,17.0766129 17.0766129,22 11,22 C4.9233871,22 0,17.0766129 0,11 C0,4.9233871 4.9233871,0 11,0 Z M16.0520161,10.2459677 L10.0419355,4.2358871 C9.625,3.81895161 8.95080645,3.81895161 8.53830645,4.2358871 L7.78427419,4.98991935 C7.36733871,5.40685484 7.36733871,6.08104839 7.78427419,6.49354839 L12.2907258,11 L7.78427419,15.5064516 C7.36733871,15.9233871 7.36733871,16.5975806 7.78427419,17.0100806 L8.53830645,17.7641129 C8.95524194,18.1810484 9.62943548,18.1810484 10.0419355,17.7641129 L16.0520161,11.7540323 C16.4689516,11.3370968 16.4689516,10.6629032 16.0520161,10.2459677 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowXan);
export default __webpack_public_path__ + "static/media/arrow_xan.b16f1643b4f159ca82008dc5c32dd2e6.svg";
export { ForwardRef as ReactComponent };